import { useContext } from 'react';
import { DropdownDataContext } from './dropdownDataContext';

const useDropdown = () => {
    const context = useContext(DropdownDataContext);

    if (!context) throw new Error('dropdown context must be use inside DropdownDataProvider');

    return context;
};

export default useDropdown;